module.exports = __webpack_public_path__ + "img/step2.95a1db29.webp";